module.exports = __webpack_public_path__ + "static/media/selo.32dc71a9.png";